import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['accounting-periods']);

export const accountingPeriodsQueryKeys = {
  all: builder(),
  one: (id: number) => builder('one', id),
  closureChecks: (id: number) => builder('closure-checks', id),
};
